<template>
  <div class="breadcrumb-container">
    <Breadcrumb class="custom-breadcrumb">
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"
        v-if="breadcrumbItems && breadcrumbItems.length > 0 && breadcrumbItems[0].machine"></WebSocket>
      <BreadcrumbItem v-for="item in breadcrumbItems" :key="item.name" :to="item.to" class="breadcrumb-item">
        <div class="breadcrumb-content menu-actions">
          <span class="breadcrumb-text">
            <template v-if="sideBar != ''">
              <div class="breadcrumb-block">
                <!-- 当前设备 -->
                <div class="breadcrumb-item-description">
                  <span class="device-title" style="">
                    {{ getTranslation('k261') }}：
                  </span>
                  <span class="device" style="">
                    {{ item.title[1] }}
                  </span>
                </div>
                <!-- 区域 -->
                <div class="breadcrumb-item-description">
                  <span class="region-title">
                    {{ getTranslation('u045') }}：
                  </span>
                  <span class="region">
                    {{ item.title[0] }}
                  </span>
                </div>

                <!-- 软件版本 -->
                <div class="breadcrumb-item-description">
                  <span class="software-title">
                    {{ getTranslation('p076') }}：
                  </span>
                  <span class="software">
                    {{ item.title[2] }}
                  </span>
                </div>

                <!-- BOOT版本 -->
                <div class="breadcrumb-item-description">
                  <span class="boot-title">
                    {{ getTranslation('r026') }}：
                  </span>
                  <span class="boot">
                    {{ item.title[3] }}
                  </span>
                </div>
              </div>
            </template>
          </span>
          <div class="breadcrumb-actions">
            <template v-if="sideBar != '' && item.machine && (item.machine.state != 1 && item.machine.state != 4)">
              <div class="status-badge status-offline">
                <span class="status-text">{{ getTranslation('m036') }}</span>
              </div>
              <Button type="success" icon="md-link" class="action-btn online-btn" :loading="machineLoading"
                @click.stop.prevent="online(item.machine.id)" size="small">{{ getTranslation("l002") }}</Button>
            </template>
            <template v-else-if="sideBar != '' && item.machine && (item.machine.state == 1)">
              <div class="status-badge status-online">
                <span class="status-text">{{ getTranslation('m035') }}</span>
              </div>
              <Button type="warning" icon="md-power" class="action-btn offline-btn"
                @click.stop.prevent="offline(item.machine.id)" size="small">{{ getTranslation("m001") }}</Button>
            </template>
            <template v-else-if="sideBar != '' && item.machine && (item.machine.state == 4)">
              <div class="status-badge status-reconnecting">
                <span class="status-text">{{ getTranslation('m090') }}</span>
              </div>
              <Button type="error" icon="md-power" class="action-btn offline-btn"
                @click.stop.prevent="offline(item.machine.id)" size="small">{{ getTranslation("m001") }}</Button>
            </template>
            <template v-if="sideBar != ''">
              <Button type="error" icon="md-warning" class="warn-btn" :disabled="warnDisabled(warnListData,item.machine)"
                @click.stop.prevent="showWanList(warnListData[item.machine.id])" size="small" >
                {{ getTranslation("l005") }}：{{ showWarnLength(warnListData, item.machine) }}
              </Button>
            </template>
          </div>
        </div>
      </BreadcrumbItem>
    </Breadcrumb>
    <WarnList v-model="visiableError" :propVisible="visiableError" :errorData="errorData"></WarnList>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError } from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';
import WarnList from '@/components/WarnList.vue';
export default {
  name: 'AppBreadcrumb',
  props: {
    sideBar: {
      type: String,
      default: ''
    },
  },
  components: {
     WebSocket, WarnList
  },
  computed: {
    ...mapState(['breadcrumbItems']),
    ...mapGetters(['getTranslation']),
    ...mapState(['warnListData']),
    webSocketUrl() {
      return API_URL['webSocket'] + "?mac=" + (this.$route.query.mac ? this.$route.query.mac :'');
    },
   
  },
  data() {
    return {
      visiableError: false,
      errorData: {},
      machineLoading:false,
    }
  },
  methods: {
    async online(id) {
      let url = API_URL["machineOnline"];
      let params = {
        id: id
      }
      this.machineLoading = true;
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if(res){
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(1);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        this.machineLoading = false;
    },
    async offline(id) {
      let url = API_URL["machineOffline"];
      let params = {
        id: id
      }
      this.machineLoading = true;
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if(res){
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(0);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        this.machineLoading = false;
    },
    setMachineState(state) {
      if (this.breadcrumbItems.length > 0) {
        this.breadcrumbItems[0].machine.state = state;

        this.$store.commit('setBreadcrumbItems', [
          { title: this.breadcrumbItems[0].title, machine: this.breadcrumbItems[0].machine }
        ]);
      }
    },
    showWanList(data) {
      this.errorData = data
      this.visiableError = true;
    },
    closeError() {
      this.visiableError = false;
    },
    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'warnList':
            if (obj.data.macId == this.breadcrumbItems[0].machine.id) {
              const macId = obj.data.macId;
              if (obj.data.clear) {
                this.$store.commit('setWarnList', { macId, data: null });
              } else {
                const currentList = this.warnListData[macId];
                if (currentList && currentList.alarms && obj.data.alarms) {
                  const removeItems = obj.data.alarms.filter(a => a.kind === 1);
                  const addItems = obj.data.alarms.filter(a => a.kind === 0);

                  let alarms = [...currentList.alarms];

                  // kind=1: remove items with matching msgId
                  if (removeItems.length > 0) {
                    const removeMsgIds = new Set(removeItems.map(a => a.msgId));
                    alarms = alarms.filter(a => !removeMsgIds.has(a.msgId));
                  }

                  // kind=0: add new items (dedup by msgId)
                  if (addItems.length > 0) {
                    const existingIds = new Set(alarms.map(a => a.msgId));
                    const newAlarms = addItems.filter(a => !existingIds.has(a.msgId));
                    alarms = [...alarms, ...newAlarms];
                  }

                  this.$store.commit('setWarnList', {
                    macId,
                    data: { ...currentList, alarms }
                  });
                } else {
                  this.$store.commit('setWarnList', { macId, data: obj.data });
                }
              }
            }
            break;
       
          case 'state':
            if (this.breadcrumbItems.length > 0) {
              if (obj.data.macId == this.breadcrumbItems[0].machine.id) {
                if (obj.data.offline === true) {
                  this.setMachineState(0)
                } else {
                  if (obj.data.netState === 0) {
                    this.setMachineState(4)
                  } else if (obj.data.netState === 1) {
                    this.setMachineState(1)
                  }
                }
              }
            }
            break;
          default:
            break;
        }
      }
    },
    warnDisabled(warnListData, item){
      const data = warnListData[item.id];
      if (item.state == 1 || item.state==2){
        return !data || !data.alarms || data.alarms.length == 0
      }else {
        return true;
      }
    },
    showWarnLength(warnListData, item) {
      const data = warnListData[item.id];
       if (item.state == 1 || item.state==2){
        return (data && data.alarms && data.alarms.length) || 0
      }else {
        return 0;
      }
    }
  },

}
</script>
<style scoped>
.breadcrumb-container {
  margin: 10px 0;
  /* 减小外边距 */
}

.custom-breadcrumb {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.breadcrumb-item {
  display: flex;
  align-items: center;

}

.breadcrumb-content {
  display: flex;
  align-items: center;
  gap: 6px;
  /* 减小间隙 */
  height: 100%;
}

.breadcrumb-text {
  font-size: 14px;
  color: #515a6e;
  font-weight: normal;
  line-height: 1.2;
  /* 减小行高 */
}

.breadcrumb-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  /* 减小间隙 */
}

.action-btn {
  font-size: 12px;
  padding: 0 8px;
  /* 减小左右内边距 */
  height: 24px;
  /* 减小按钮高度 */
  line-height: 20px;
  /* 调整行高匹配高度 */
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.online-btn {
  background-color: #19be6b;
  border-color: #19be6b;
  color: #fff;
}

.online-btn:hover {
  background-color: #16a85a;
  border-color: #16a85a;
}

.offline-btn {
  background-color: #ff9900;
  border-color: #ff9900;
  color: #fff;
}

.offline-btn:hover {
  background-color: #e68a00;
  border-color: #e68a00;
}

.status-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  /* 减小内边距 */
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  min-width: 60px;
  height: 24px;
  /* 与按钮高度一致 */
}

.status-text {
  font-size: 12px;
  font-weight: 500;
}

.status-offline {
  background-color: #f8f8f9;
  color: #808695;
  border: 1px solid #dcdee2;
}

.status-online {
  background-color: #19be6b;
  color: #ffffff;
  border: 1px solid #19be6b;
}

.status-reconnecting {
  background-color: #ff9900;
  color: #ffffff;
  border: 1px solid #ff9900;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}





/* Override default breadcrumb styles */
.custom-breadcrumb>>>.ivu-breadcrumb {
  line-height: 1.2;
  /* 减小面包屑整体行高 */
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-separator {
  color: #c5c8ce;
  margin: 0 6px;
  /* 减小分隔符间距 */
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-link {
  color: #515a6e;
  font-weight: normal;
  text-decoration: none;
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-link:hover {
  color: #2d8cf0;
}

.custom-breadcrumb>>>.ivu-breadcrumb>span:last-child .ivu-breadcrumb-item-link {
  color: #17233d;
  font-weight: normal;
}

.breadcrumb-block {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  padding: 0 8px;
  font-family: system-ui, -apple-system, sans-serif;
  align-items: center;
}

.breadcrumb-item-description {
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  margin-right:10px;  
}

.device-title {  
  padding: 2px 0px; 
  white-space: nowrap;
}

.device {
  background-color: #e8f4fd;
  color: #0066cc;
  padding: 2px 6px;
  white-space: nowrap;
}

.region-title { 
  padding: 2px 0px; 
  white-space: nowrap;
}

.region {
  background-color: #e8f7ed;
  color: #0a7c42;
  padding: 2px 6px; 
  white-space: nowrap;
}

.software-title { 
  padding: 2px 0px; 
  white-space: nowrap;
}

.software {
  background-color: #fef7e6;
  color: #b26000;
  padding: 2px 6px; 
  white-space: nowrap;
}

.boot-title {
  padding: 2px 0px;
  white-space: nowrap;
}

.boot {
  background-color: #f3e8ff;
  color: #6d28d9;
  padding: 2px 6px; 
  white-space: nowrap;
}
</style>